export default {
  sumCalculate: {},
  sumCalculateDisable: false,
  basketOrder: '',
  basket: [],
  currency: '',
  currencyLabel: '',
  basketServices: null,
  basketServicesData: null,
  basketEdit: {
    index: '',
    state: false,
  },
  basketEditOrder: false,
  basketItemIndex: '',
  basketDiscountValue: [
    {
      label: 'Скидка в процентах',
      value: 2,
    },
  ],
}
